var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"rb-particles"},_vm._l((_vm.elements),function(i){return _c(_vm.getParticleType(i),{key:i,tag:"component",staticClass:"particle",on:{"destroy":function($event){return _vm.removeElement(i)}}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }